import {
  Dropdown,
  Table,
  Form,
  Button,
  InputGroup,
  Badge,
} from "react-bootstrap";
import { CSVLink } from "react-csv";
import {
  ExportIcon,
  FilterTwoIcon,
  SummaryChartIconUp,
  SummaryCloseIcon,
  FilterCollapseIcon,
  ExcelIcon,
  PDFIcon,
  MoneyDollarIcon,
} from "../../Icons";
import SettleIncentiveModal from "./SettleIncentiveModal";
import "../../../assets/scss/reports/cashbook.scss";
import { useEffect, useRef, useState } from "react";
import CachedIcon from "mdi-react/CachedIcon";
import Select from "react-select";
import useDebounce, {
  useLocalStorage,
  useQueryParams,
  useScrollTop,
} from "../../../utils/hooks";
import { useQuery } from "react-query";
import { endOfMonth, format, parse, startOfMonth } from "date-fns";
import ReactPaginate from "react-paginate";
import {
  defaultSelectValue,
  formatDate,
  paginationOptions,
  reactSelectTheme,
} from "../../../utils/helpers";
import RsDateRangePicker from "../../utils/RsDateRangePicker";
import queryString from "query-string";
import { useAuth } from "../../../hooks/useAuth";
import { isEmpty } from "lodash";
import NoTableItem from "../../utils/NoTableItem";
import { useDownloadExcel } from "../../../hooks/useDownloadExcel";
import ModalLoader from "../../utils/ModalLoader";
import VendorSelector from "../../Vendor/VendorSelector";
import { Popover } from "react-tiny-popover";
import MagnifyIcon from "mdi-react/MagnifyIcon";
import { Link } from "react-router-dom";
import MonthYearPicker from "../../utils/MonthYearPicker";
import DotsVerticalIcon from "mdi-react/DotsVerticalIcon";
import currency from "currency.js";
import ApprovalBadge from "../../utils/ApprovalBadge";

const statusOptions = [
  { label: "All", value: "" },
  { label: "Not Loaded", value: "Not Loaded" },
  { label: "Partially Loaded", value: "Partially Loaded" },
  { label: "Loaded", value: "Loaded" },
];

const formatMoney = value => {
  if (value === null || value === undefined || value === "") {
    value = 0;
  }

  const numericValue = Number(value);
  if (Number.isNaN(numericValue)) return value;

  return new Intl.NumberFormat("en-NG", {
    style: "currency",
    currency: "NGN",
    maximumFractionDigits: 2,
  }).format(numericValue);
};

export default function DueIncentives() {
  useScrollTop();

  const initialFilterParams = {
    // q: "",
    // Status: "",
    // enableDateRange: true,
    // Vendor_ID: "",

    startDate: format(startOfMonth(new Date()), "yyyy-MM-dd"),
    endDate: format(endOfMonth(new Date()), "yyyy-MM-dd"),
    month: format(new Date(), "M"), // current month 1,2,3,4
    year: format(new Date(), "yyyy"), // current year 2026, 2027
  };

  const { backendUrl } = useAuth();

  const [showFilter, setShowFilter] = useLocalStorage("showFilter", true);
  const [btnSummryActive, setBtnSummaryActive] = useState(false);
  const [excelData, setExcelData] = useState([]);
  const [showVendorPopover, setShowVendorPopover] = useState(false);
  const [showSettleModal, setShowSettleModal] = useState(false);
  const [selectedIncentive, setSelectedIncentive] = useState(null);
  const [settleAll, setSettleAll] = useState(false);

  const CSVLinkRef = useRef(null);

  const [isfetchingExcel, fetchExcelData] = useDownloadExcel(
    excelData,
    CSVLinkRef
  );

  const close = () => {
    setBtnSummaryActive(false);
  };

  const [queryParams, setQueryParams] = useQueryParams({
    page: 1,
    limit: 40,
    ...initialFilterParams,
  });

  const [filterParams, setFilterParams] = useState({
    ...initialFilterParams,
    ...queryParams,
  });

  const debouncedFilterParams = useDebounce(filterParams, 500);
  useEffect(() => {
    setQueryParams({
      ...queryParams,
      ...debouncedFilterParams,
    });
  }, [debouncedFilterParams]);

  const fetchStocking = async queryParams => {
    let response = await fetch(
      `${backendUrl}/api/incentive/due-incentives?${queryString.stringify(
        queryParams
      )}`,
      {
        method: "GET",
        headers: {
          Accept: "Application/json",
          "Content-Type": "Application/json",
        },
        credentials: "include",
      }
    );

    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }

    const { data } = await response.json();
    return data;
  };

  const {
    data = {
      count: 0,
      incentives: [],
    },
    refetch,
    isSuccess,
    isFetching,
  } = useQuery(
    ["DUE_INCENTIVES", queryParams],
    () => fetchStocking(queryParams),
    {
      keepPreviousData: true,
    }
  );

  const fetchReconciliation = async ({ month, year }) => {
    let response = await fetch(
      `${backendUrl}/api/incentive/reconciliation?${queryString.stringify({
        month,
        year,
      })}`,
      {
        method: "GET",
        headers: {
          Accept: "Application/json",
          "Content-Type": "Application/json",
        },
        credentials: "include",
      }
    );

    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }

    const { data } = await response.json();
    return data;
  };

  const { data: reconciliationData = { reconciliation: [] } } = useQuery(
    ["INCENTIVE_RECONCILIATION", filterParams.month, filterParams.year],
    () =>
      fetchReconciliation({
        month: filterParams.month,
        year: filterParams.year,
      }),
    {
      keepPreviousData: true,
      enabled: btnSummryActive,
    }
  );

  const reconciliationRows = reconciliationData?.reconciliation || [];
  const reconciliationTotals = reconciliationRows.reduce(
    (acc, el) => ({
      recognised: currency(acc.recognised).add(el.recognised || 0).value,
      received: currency(acc.received).add(el.received || 0).value,
      variance: currency(acc.variance).add(el.variance || 0).value,
    }),
    { recognised: 0, received: 0, variance: 0 }
  );

  const { limit, page, ...rest } = queryParams;
  const onDownloadExcelData = async () => {
    let exData = await fetchExcelData(
      `${backendUrl}/api/incentives/due-incentives?${queryString.stringify(
        rest
      )}`,
      "GET"
    );

    const company = exData.data?.company?.CompName;

    exData = (
      exData.data?.dueIncentives ||
      exData.data?.vendorLedgers ||
      []
    ).map(d => [
      d.Trans_ID || "",
      formatMoney(d.AmountDue),
      formatMoney(d.AmountPaid),
      formatMoney(d.Balance),
    ]);

    const date =
      rest.startDate && rest.endDate
        ? `Date Prepared: Between ${format(
            new Date(rest.startDate),
            "E MMM d yyyy"
          )} to ${format(new Date(rest.endDate), "E MMM d yyyy")}`
        : "";

    exData = [
      [company],
      ["Due Incentives Report"],
      [date],
      [""],
      ["Transaction ID", "Amount Due", "Amount Paid", "Balance"],
      ...exData,
    ];

    setExcelData(exData);
  };

  const handleFilterParamsChange = e => {
    setFilterParams({
      ...filterParams,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };

  const handleSearchQueryChange = e => {
    setQueryParams({
      ...queryParams,
      [e.target.name]: e.target.value,
    });
  };

  const filterByDateRange = date => {
    setFilterParams({
      ...filterParams,
      startDate: format(date[0], "yyyy-MM-dd"),
      endDate: format(date[1], "yyyy-MM-dd"),
      enableDateRange: true,
    });
  };

  const clearDateRange = () => {
    setFilterParams({
      ...filterParams,
      startDate: "",
      endDate: "",
    });
  };

  const search = () => {
    setQueryParams({
      ...queryParams,
      ...filterParams,
    });
  };

  const reset = () => {
    setFilterParams(initialFilterParams);
    setQueryParams({
      ...queryParams,
      ...initialFilterParams,
    });
  };

  const handleSelectedVendor = vendor => {
    setFilterParams({
      ...filterParams,
      Vendor_ID: vendor.Vendor_ID,
    });
    setShowVendorPopover(false);
  };

  return (
    <main className="cash-book">
      <div className="content">
        <div className="content-main">
          <div className={`filter-area ${showFilter ? "open" : "close"}`}>
            <div className="filter-header">
              <h2>
                <FilterTwoIcon /> Filters
              </h2>
              <Button
                variant="white"
                onClick={() => setShowFilter(!showFilter)}
              >
                <FilterCollapseIcon />
              </Button>
            </div>
            <div className="filter-body">
              <Form>
                <div className="body">
                  <Form.Group className="mb-2-5">
                    <Form.Label>Transaction ID</Form.Label>
                    <Form.Control
                      name="q"
                      placeholder="Search transaction ID..."
                      value={filterParams.q}
                      onChange={e => handleFilterParamsChange(e)}
                    />
                  </Form.Group>

                  <Form.Group className="mb-2-5">
                    <Form.Label>Vendor ID</Form.Label>
                    <InputGroup>
                      <Form.Control
                        name="Vendor_ID"
                        placeholder="Enter Vendor ID"
                        value={filterParams?.Vendor_ID}
                        onChange={() => {}}
                        readOnly
                      />
                      <Popover
                        isOpen={showVendorPopover}
                        onClickOutside={() => setShowVendorPopover(false)}
                        content={() => (
                          <VendorSelector
                            handleSelectedCustomer={handleSelectedVendor}
                            setShowCustomerSelector={setShowVendorPopover}
                          />
                        )}
                        position="bottom"
                      >
                        <InputGroup.Text
                          onClick={() =>
                            setShowVendorPopover(!showVendorPopover)
                          }
                        >
                          <MagnifyIcon />
                        </InputGroup.Text>
                      </Popover>
                    </InputGroup>
                  </Form.Group>

                  {/* <Form.Group className="mb-2-5">
                    <Form.Label>Status</Form.Label>
                    <Select
                      classNamePrefix="form-select"
                      placeholder="All"
                      name="Status"
                      theme={reactSelectTheme}
                      isSearchable={false}
                      onChange={selected => {
                        setFilterParams({
                          ...filterParams,
                          Status: selected.value,
                        });
                      }}
                      defaultValue={defaultSelectValue(
                        queryParams?.Status,
                        statusOptions,
                        { value: "", label: "All" }
                      )}
                      options={statusOptions}
                    />
                  </Form.Group> */}

                  {/* <hr className="mt-1 mb-4" /> */}

                  {/* <Form.Group className="">
                    <Form.Label>Date Range</Form.Label>
                    <div className="position-relative">
                      <RsDateRangePicker
                        placement="auto"
                        value={
                          filterParams.startDate && filterParams.endDate
                            ? [
                                parse(
                                  filterParams.startDate,
                                  "yyyy-MM-dd",
                                  new Date()
                                ),
                                parse(
                                  filterParams.endDate,
                                  "yyyy-MM-dd",
                                  new Date()
                                ),
                              ]
                            : []
                        }
                        onClean={() => clearDateRange()}
                        onOk={date => filterByDateRange(date)}
                      />
                    </div>
                  </Form.Group> */}
                </div>

                <div className="buttons rounded">
                  <Button onClick={() => reset()} variant="white">
                    Reset
                  </Button>
                  <Button onClick={() => search()} variant="primary">
                    Search
                  </Button>
                </div>
              </Form>
            </div>
          </div>

          <div className="content-body">
            <header>
              <h1>
                {!showFilter && (
                  <button
                    onClick={() => setShowFilter(!showFilter)}
                    className="btn filter"
                  >
                    <FilterTwoIcon />
                  </button>
                )}
                Incentive Report
                <button onClick={() => refetch()} className="btn text-primary">
                  <CachedIcon />
                </button>
              </h1>

              <div className="actions mr-5">
                <div style={{ zIndex: 10 }}>
                  <MonthYearPicker
                    onMonthChange={month => {
                      const monthIndex = Number(month) - 1;

                      setFilterParams({
                        ...filterParams,
                        month: month || "",
                        startDate: format(
                          startOfMonth(new Date(filterParams.year, monthIndex)),
                          "yyyy-MM-dd"
                        ),
                        endDate: format(
                          endOfMonth(new Date(filterParams.year, monthIndex)),
                          "yyyy-MM-dd"
                        ),
                      });
                    }}
                    onYearChange={year => {
                      const monthIndex = Number(filterParams.month) - 1;

                      setFilterParams({
                        ...filterParams,
                        year: year || "",
                        startDate: format(
                          startOfMonth(new Date(year, monthIndex)),
                          "yyyy-MM-dd"
                        ),
                        endDate: format(
                          endOfMonth(new Date(year, monthIndex)),
                          "yyyy-MM-dd"
                        ),
                      });
                    }}
                    yearValue={filterParams?.year}
                    monthValue={Number(filterParams?.month)}
                    variant="filter"
                    monthLabel=""
                    yearLabel=""
                  />
                </div>
                {/* <Button
                  onClick={() => {
                    setSelectedIncentive(null);
                    setSettleAll(true);
                    setShowSettleModal(true);
                  }}
                  // disabled={!data?.incentives?.length}
                  disabled={true}
                >
                  Settle All Outstanding
                </Button> */}

                <CSVLink
                  className="btn print d-none"
                  filename={`Due Incentives(${format(
                    new Date(),
                    "dd-MMM-yyyy hh:mm:ss a"
                  )}).csv`}
                  data={excelData}
                  ref={CSVLinkRef}
                />

                {/* <Link
                  className="btn btn-outline-primary px-3 d-flex align-items-center"
                  to="/load-atc"
                >
                  Split & Load ATC
                </Link> */}

                {/* <Dropdown>
                  <Dropdown.Toggle
                    variant=""
                    className="btn print"
                    disabled={isfetchingExcel}
                    bsPrefix=""
                  >
                    <ExportIcon color="#008000" />
                    Export
                  </Dropdown.Toggle>
                  <Dropdown.Menu
                    popperConfig={{ strategy: "fixed" }}
                    renderOnMount
                    className="text-center"
                  >
                    <Dropdown.Item
                      as="div"
                      onClick={onDownloadExcelData}
                      className="p-cursor"
                    >
                      Excel <ExcelIcon color="#008000" />
                    </Dropdown.Item>
                    <Dropdown.Item as="div">
                      <a
                        href={`${backendUrl}/api/vendors/ledger/pdf?${queryString.stringify(
                          rest
                        )}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        PDF <PDFIcon color="#ff0000" />
                      </a>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown> */}

                {/* <button
                  onClick={() => setBtnSummaryActive(true)}
                  className="btn summaryBtnWhite btn-outline-primary"
                >
                  Show Summary
                </button> */}
              </div>
            </header>

            <div className="px-md-4">
              <Table responsive borderless striped className="product-table">
                <thead>
                  <tr>
                    <th />
                    <th />
                    <th>Trans ID</th>
                    <th>Incentive</th>
                    <th>Item/SKU</th>
                    <th>Amount Due</th>
                    <th>Amount Paid</th>
                    <th>Balance</th>
                    <th />
                    <th>Purchase Date</th>
                  </tr>
                </thead>
                <tbody>
                  {(data?.incentives).map((el, index) => (
                    <tr
                      key={index}
                      style={
                        el.amountDue === 0
                          ? {
                              pointerEvents: "none",
                              opacity: 0.5,
                            }
                          : {}
                      }
                    >
                      <td>
                        {/*  */}

                        <Dropdown alignRight drop="end">
                          <Dropdown.Toggle
                            variant=""
                            className="bg-white border-0"
                            bsPrefix="print more"
                          >
                            <DotsVerticalIcon />
                          </Dropdown.Toggle>
                          <Dropdown.Menu
                            popperConfig={{
                              strategy: "fixed",
                            }}
                            renderOnMount
                            className="dropdown-with-icons"
                            style={{
                              maxHeight: "90vh",
                              overflowY: "auto",
                            }}
                          >
                            <Dropdown.Item as="button">
                              <Link
                                target="_blank"
                                to={`/inventory-for-sales/batches?InvoiceNo=${
                                  el?.transId
                                }`}
                              >
                                View ATCs
                              </Link>
                            </Dropdown.Item>
                          </Dropdown.Menu>{" "}
                        </Dropdown>
                      </td>
                      <td>
                        {el.remaining > 0 && (
                          <Button
                            variant="outline-primary"
                            size="sm"
                            onClick={() => {
                              setSettleAll(false);
                              setSelectedIncentive(el);
                              setShowSettleModal(true);
                            }}
                          >
                            Settle
                          </Button>
                        )}
                      </td>
                      <td>{el.transId || "—"}</td>
                      <td>{el.incentiveRef?.Name || "—"}</td>
                      <td>
                        <div style={{ minWidth: 250 }}>
                          {el.purchaseRef?.ATC_Item_Name || "—"}
                          <br />
                          <small>
                            <b>Plant:&nbsp;</b> {el.purchaseRef?.Plant || "..."}
                            &nbsp;&nbsp; <b>Region:&nbsp;</b>
                            {el.purchaseRef?.Region || "..."}&nbsp;&nbsp;{" "}
                            <b>Depot:&nbsp;</b>
                            {el.purchaseRef?.Depot || "..."}&nbsp;&nbsp;{" "}
                          </small>
                        </div>
                      </td>
                      <td title={el.amountDue} className="text-nowrap">
                        {formatMoney(el.amountDue)}
                      </td>
                      <td title={el.amountPaid} className="text-nowrap">
                        {formatMoney(el.amountPaid)}
                      </td>
                      <td title={el.remaining} className="text-nowrap">
                        {formatMoney(el.remaining)}
                      </td>
                      <td>
                        {el.remaining === 0 ? (
                          <ApprovalBadge
                            className="approval"
                            bg="success"
                            text="Paid"
                          />
                        ) : (
                          <ApprovalBadge
                            className="approval"
                            bg="orange-warning"
                            text="Due"
                          />
                        )}
                      </td>
                      <td className="text-nowrap">
                        {el?.purchaseRef?.Post_Date
                          ? formatDate(el?.purchaseRef?.Post_Date)
                          : null}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <SettleIncentiveModal
                show={showSettleModal}
                onClose={() => {
                  setShowSettleModal(false);
                  setSelectedIncentive(null);
                  setSettleAll(false);
                }}
                onSuccess={() => refetch()}
                incentive={selectedIncentive}
                month={filterParams.month}
                year={filterParams.year}
                settleAll={settleAll}
                totalAmount={data?.incentives?.reduce(
                  (sum, item) =>
                    sum + Number(item?.Balance || item?.AmountDue || 0),
                  0
                )}
              />

              {!isFetching && isSuccess && isEmpty(data?.incentives) ? (
                <NoTableItem queryParams={queryParams} />
              ) : null}
            </div>

            <div className="d-flex justify-content-between px-3 align-items-center pagination">
              <div className="pagination_left">
                <p className="m-0 p-0">Show</p>
                <select
                  value={queryParams.limit}
                  name="limit"
                  className="form-select"
                  onChange={e => handleSearchQueryChange(e)}
                >
                  <option value="10">10 rows</option>
                  <option value="20">20 rows</option>
                  <option value="30">30 rows</option>
                  <option value="40">40 rows</option>
                  <option value="50">50 rows</option>
                  <option value="100">100 rows</option>
                </select>
              </div>

              <ReactPaginate
                {...paginationOptions}
                pageCount={Math.ceil(data.count / queryParams.limit)}
                marginPagesDisplayed={2}
                pageRangeDisplayed={0}
                onPageChange={({ selected }) => {
                  document.body.scrollTop = document.documentElement.scrollTop = 0;
                  setQueryParams({
                    ...queryParams,
                    page: selected + 1,
                  });
                }}
                forcePage={queryParams.page - 1}
              />
            </div>

            <div
              className={
                btnSummryActive
                  ? `summaryNew border-top open`
                  : `summaryNew border-top`
              }
            >
              <div className="summaryHeader">
                <h2>
                  Summary — {filterParams.month}/{filterParams.year}
                </h2>
                {btnSummryActive && (
                  <button onClick={() => close()} className="btn p-0">
                    <SummaryCloseIcon />
                  </button>
                )}
              </div>

              <div className="gridCont">
                <div className="gridChild gridChildBorderLeftBlue">
                  <div className="gridChildLeft">
                    <p className="gridChld1">
                      {formatMoney(reconciliationTotals.recognised)}
                    </p>
                    <p className="gridChld2">Due</p>
                  </div>
                </div>

                <div className="gridChild gridChildBorderLeftBlue">
                  <div className="gridChildLeft">
                    <p className="gridChld1">
                      {formatMoney(reconciliationTotals.received)}
                    </p>
                    <p className="gridChld2">Paid</p>
                  </div>
                </div>

                <div className="gridChild gridChildBorderLeftOrange">
                  <div className="gridChildLeft">
                    <p className="gridChld1">
                      {formatMoney(reconciliationTotals.variance)}
                    </p>
                    <p className="gridChld2">Balance</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModalLoader show={isfetchingExcel} />
    </main>
  );
}
